{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://aiwg.io/schemas/aiwg-fortemi-index-export.json",
  "title": "AIWG Fortemi Index Export",
  "type": "object",
  "additionalProperties": false,
  "required": ["schema_version", "generated_at", "source", "items"],
  "properties": {
    "schema_version": {
      "enum": ["aiwg.fortemi.index.export.v1", "aiwg.fortemi.index.export.v2"]
    },
    "generated_at": {
      "type": "string",
      "format": "date-time"
    },
    "source": {
      "type": "object",
      "additionalProperties": false,
      "required": ["repo", "privacy"],
      "properties": {
        "repo": {
          "type": "string",
          "minLength": 1
        },
        "privacy": {
          "$ref": "#/$defs/privacy"
        },
        "graph": {
          "type": "string",
          "minLength": 1
        }
      }
    },
    "compatibility": {
      "type": "object",
      "additionalProperties": false,
      "required": ["previous_schema_version", "strategy"],
      "properties": {
        "previous_schema_version": {
          "const": "aiwg.fortemi.index.export.v1"
        },
        "strategy": {
          "const": "supported"
        }
      }
    },
    "items": {
      "type": "array",
      "items": {
        "$ref": "#/$defs/record"
      }
    }
  },
  "allOf": [
    {
      "if": {
        "properties": {
          "schema_version": {
            "const": "aiwg.fortemi.index.export.v1"
          }
        }
      },
      "then": {
        "not": {
          "required": ["compatibility"]
        },
        "properties": {
          "source": {
            "not": {
              "required": ["graph"]
            }
          },
          "items": {
            "items": {
              "allOf": [
                {
                  "properties": {
                    "schema_version": {
                      "const": "aiwg.fortemi.index.record.v1"
                    }
                  }
                },
                {
                  "$ref": "#/$defs/v1RecordCompatibility"
                }
              ]
            }
          }
        }
      }
    },
    {
      "if": {
        "properties": {
          "schema_version": {
            "const": "aiwg.fortemi.index.export.v2"
          }
        }
      },
      "then": {
        "required": ["compatibility"],
        "properties": {
          "source": {
            "required": ["graph"]
          },
          "items": {
            "items": {
              "properties": {
                "schema_version": {
                  "const": "aiwg.fortemi.index.record.v2"
                }
              }
            }
          }
        }
      }
    }
  ],
  "$defs": {
    "privacy": {
      "enum": ["private", "sanitized", "public"]
    },
    "recordType": {
      "type": "string",
      "minLength": 1
    },
    "stringArray": {
      "type": "array",
      "items": {
        "type": "string"
      }
    },
    "numberArray": {
      "type": "array",
      "items": {
        "type": "number"
      }
    },
    "v1RecordCompatibility": {
      "type": "object",
      "not": {
        "anyOf": [
          {
            "required": ["name"]
          },
          {
            "required": ["summary"]
          },
          {
            "required": ["search"]
          },
          {
            "required": ["chunks"]
          },
          {
            "required": ["embeddings"]
          },
          {
            "required": ["compatibility"]
          },
          {
            "required": ["skos_concepts"]
          },
          {
            "required": ["skos_relations"]
          },
          {
            "required": ["provenance_events"]
          },
          {
            "required": ["operational_state"]
          },
          {
            "required": ["state_transfer"]
          }
        ]
      },
      "properties": {
        "source": {
          "not": {
            "anyOf": [
              {
                "required": ["origin"]
              },
              {
                "required": ["generated"]
              },
              {
                "required": ["checksum"]
              },
              {
                "required": ["updated_at"]
              }
            ]
          }
        },
        "relationships": {
          "items": {
            "not": {
              "anyOf": [
                {
                  "required": ["target_path"]
                },
                {
                  "required": ["direction"]
                },
                {
                  "required": ["label"]
                },
                {
                  "required": ["confidence"]
                },
                {
                  "required": ["privacy"]
                },
                {
                  "required": ["metadata"]
                }
              ]
            }
          }
        },
        "privacy": {
          "not": {
            "required": ["locality"]
          }
        }
      }
    },
    "record": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "schema_version",
        "id",
        "type",
        "source",
        "title",
        "text",
        "facets",
        "tags",
        "concepts",
        "relationships",
        "provenance",
        "privacy",
        "updated_at"
      ],
      "properties": {
        "schema_version": {
          "enum": [
            "aiwg.fortemi.index.record.v1",
            "aiwg.fortemi.index.record.v2"
          ]
        },
        "id": {
          "type": "string",
          "minLength": 1
        },
        "type": {
          "$ref": "#/$defs/recordType"
        },
        "source": {
          "type": "object",
          "additionalProperties": false,
          "required": ["path", "repo_relative_path", "locator"],
          "properties": {
            "path": {
              "type": "string",
              "minLength": 1
            },
            "repo_relative_path": {
              "type": "string",
              "minLength": 1
            },
            "locator": {
              "type": "string",
              "minLength": 1
            },
            "origin": {
              "type": "string",
              "minLength": 1
            },
            "generated": {
              "type": "boolean"
            },
            "checksum": {
              "type": "string"
            },
            "updated_at": {
              "type": "string",
              "format": "date-time"
            }
          }
        },
        "title": {
          "type": "string"
        },
        "name": {
          "type": "string"
        },
        "summary": {
          "type": "string"
        },
        "text": {
          "type": "string"
        },
        "search": {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "title",
            "body",
            "triggers",
            "aliases",
            "tags",
            "frontmatter"
          ],
          "properties": {
            "title": {
              "type": "string"
            },
            "name": {
              "type": "string"
            },
            "summary": {
              "type": "string"
            },
            "body": {
              "type": "string"
            },
            "triggers": {
              "$ref": "#/$defs/stringArray"
            },
            "aliases": {
              "$ref": "#/$defs/stringArray"
            },
            "capability": {
              "type": "string"
            },
            "tags": {
              "$ref": "#/$defs/stringArray"
            },
            "phase": {
              "type": "string"
            },
            "type": {
              "type": "string"
            },
            "frontmatter": {
              "type": "object"
            }
          }
        },
        "facets": {
          "type": "object",
          "additionalProperties": {
            "$ref": "#/$defs/stringArray"
          }
        },
        "tags": {
          "$ref": "#/$defs/stringArray"
        },
        "concepts": {
          "$ref": "#/$defs/stringArray"
        },
        "relationships": {
          "type": "array",
          "items": {
            "type": "object",
            "additionalProperties": false,
            "required": ["type", "target_id"],
            "properties": {
              "type": {
                "type": "string",
                "minLength": 1
              },
              "target_id": {
                "type": "string",
                "minLength": 1
              },
              "source_path": {
                "type": "string"
              },
              "target_path": {
                "type": "string"
              },
              "direction": {
                "enum": ["upstream", "downstream", "related"]
              },
              "label": {
                "type": "string"
              },
              "confidence": {
                "type": "number"
              },
              "privacy": {
                "$ref": "#/$defs/privacy"
              },
              "metadata": {
                "type": "object"
              }
            }
          }
        },
        "provenance": {
          "type": "array",
          "minItems": 1,
          "items": {
            "type": "object",
            "additionalProperties": false,
            "required": ["field", "source", "path", "confidence", "privacy"],
            "properties": {
              "field": {
                "type": "string",
                "minLength": 1
              },
              "source": {
                "type": "string",
                "minLength": 1
              },
              "path": {
                "type": "string",
                "minLength": 1
              },
              "confidence": {
                "enum": ["source", "candidate", "reviewed", "rejected"]
              },
              "privacy": {
                "$ref": "#/$defs/privacy"
              }
            }
          }
        },
        "privacy": {
          "type": "object",
          "additionalProperties": false,
          "required": ["classification", "pii"],
          "properties": {
            "classification": {
              "$ref": "#/$defs/privacy"
            },
            "pii": {
              "type": "boolean"
            },
            "locality": {
              "enum": ["project", "framework", "external"]
            }
          }
        },
        "chunks": {
          "type": "array",
          "items": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
              "id": {
                "type": "string",
                "minLength": 1
              },
              "text": {
                "type": "string"
              },
              "body": {
                "type": "string"
              },
              "summary": {
                "type": "string"
              },
              "source_path": {
                "type": "string"
              },
              "metadata": {
                "type": "object"
              },
              "checksum": {
                "type": "string"
              }
            }
          }
        },
        "embeddings": {
          "type": "array",
          "items": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
              "id": {
                "type": "string"
              },
              "model": {
                "type": "string"
              },
              "embedding": {
                "$ref": "#/$defs/numberArray"
              },
              "vector": {
                "$ref": "#/$defs/numberArray"
              },
              "granularity": {
                "type": "string"
              },
              "source_path": {
                "type": "string"
              },
              "metadata": {
                "type": "object"
              },
              "chunk_id": {
                "type": "string"
              },
              "vector_ref": {
                "type": "string"
              },
              "input_hash": {
                "type": "string"
              }
            }
          }
        },
        "compatibility": {
          "type": "object"
        },
        "skos_concepts": {
          "type": "array",
          "items": {
            "type": "object",
            "additionalProperties": false,
            "required": ["id", "prefLabel"],
            "properties": {
              "id": {
                "type": "string",
                "minLength": 1
              },
              "prefLabel": {
                "type": "string",
                "minLength": 1
              },
              "definition": {
                "type": "string"
              },
              "scheme": {
                "type": "string"
              },
              "notation": {
                "type": "string"
              },
              "uri": {
                "type": "string"
              },
              "altLabels": {
                "$ref": "#/$defs/stringArray"
              },
              "metadata": {
                "type": "object"
              }
            }
          }
        },
        "skos_relations": {
          "type": "array",
          "items": {
            "type": "object",
            "additionalProperties": false,
            "required": ["type", "source_id", "target_id"],
            "properties": {
              "type": {
                "type": "string",
                "minLength": 1
              },
              "source_id": {
                "type": "string",
                "minLength": 1
              },
              "target_id": {
                "type": "string",
                "minLength": 1
              },
              "source_path": {
                "type": "string"
              },
              "metadata": {
                "type": "object"
              }
            }
          }
        },
        "provenance_events": {
          "type": "array",
          "items": {
            "type": "object",
            "additionalProperties": false,
            "required": ["activity"],
            "properties": {
              "id": {
                "type": "string"
              },
              "activity": {
                "type": "string",
                "minLength": 1
              },
              "agent": {
                "type": "string"
              },
              "started_at": {
                "type": "string",
                "format": "date-time"
              },
              "ended_at": {
                "type": "string",
                "format": "date-time"
              },
              "source": {
                "type": "string"
              },
              "path": {
                "type": "string"
              },
              "confidence": {
                "enum": ["source", "candidate", "reviewed", "rejected"]
              },
              "privacy": {
                "$ref": "#/$defs/privacy"
              },
              "attributes": {
                "type": "object"
              }
            }
          }
        },
        "operational_state": {
          "$ref": "#/$defs/operationalState"
        },
        "state_transfer": {
          "$ref": "#/$defs/stateTransfer"
        },
        "updated_at": {
          "type": "string",
          "format": "date-time"
        }
      }
    },
    "operationalState": {
      "type": "object",
      "additionalProperties": false,
      "required": ["classification"],
      "properties": {
        "source_repo": { "type": "string", "minLength": 1 },
        "source_kind": { "type": "string", "minLength": 1 },
        "source_id": { "type": "string", "minLength": 1 },
        "observed_state": { "type": "string", "minLength": 1 },
        "observed_at": { "type": "string", "format": "date-time" },
        "source_updated_at": { "type": "string", "format": "date-time" },
        "evidence_url": { "type": "string", "format": "uri" },
        "evidence_path": { "type": "string", "minLength": 1 },
        "observer": { "type": "string", "minLength": 1 },
        "supersedes": { "$ref": "#/$defs/stringArray" },
        "contradicts": { "$ref": "#/$defs/stringArray" },
        "stale_after": { "type": "string", "format": "date-time" },
        "classification": {
          "enum": ["fresh", "historical", "superseded", "contradicted", "needs-source"]
        },
        "confidence": {
          "enum": ["source", "candidate", "reviewed", "rejected"]
        },
        "current_action_selector": { "type": "boolean" }
      }
    },
    "stateTransfer": {
      "type": "object",
      "additionalProperties": false,
      "required": ["deleted_at"],
      "properties": {
        "deleted_at": {
          "type": ["string", "null"],
          "format": "date-time"
        }
      }
    }
  }
}
